import FlashLib from "flashlib";
import * as PIXI from "pixi.js";

export default class PreloaderProgressBar extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.update(0);
    }

    init() {
        this.progress = this.getChildAt(1);

        this.progressMask = new PIXI.Graphics();
        this.progressMask.beginFill(0x0, 1);
        this.progressMask.drawRect(0, 0, this.progress.width, this.progress.height);
        this.progressMask.endFill();
        this.progressMask.x = this.progress.x;
        this.progressMask.y = this.progress.y;
        this.addChild(this.progressMask);

        this.progress.mask = this.progressMask;
    }

    update(value) {
        this.progressMask.width = this.progress.width / 100 * value;
    }
}